exports.completed = [
  "Rejected",
  "No Access",
  "Closed",
  "Completed",
  "Cancelled",
];
